<rx-applications-navigation-menu class="d-none d-lg-inline-flex" />
<main class="shell-content px-2 px-lg-4 py-4">
  <router-outlet></router-outlet>
</main>